import React from "react";

const Input = ({
  labelClass,
  type,
  label,
  onChange,
  value,
  className,
  htmlFor,
  id,
}) => {
  return (
    <>
      <label
        htmlFor={htmlFor}
        className={`cursor-pointer pl-0.5 text-custom-black leading-100 max-md:text-xs ${labelClass}`}
      >
        {label}
      </label>
      <input
        id={id}
        onChange={onChange}
        value={value}
        type={type}
        className={`bg-white outline-none border-[1.5px] border-mix-white rounded-lg w-full text-base font-normal sm:py-[19px] py-3 px-4 focus:border-custom-dark-blue ${className}`}
      />
    </>
  );
};

export default Input;
